/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs */

const en_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn focus into momentum.`)
};

const ar_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حوّل تركيزك إلى زخم قوي.`)
};

const de_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwandle Fokus in pure Tatkraft.`)
};

const es_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforma el enfoque en impulso.`)
};

const fr_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez votre concentration en élan.`)
};

const it_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma la concentrazione in slancio vitale.`)
};

const ja_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その集中を、前進する推進力に変えましょう。`)
};

const ko_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중을 추진력으로 전환하세요.`)
};

const pt_br_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme o foco em impulso.`)
};

const ru_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Превратите концентрацию в движущую силу.`)
};

const th_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนสมาธิให้เป็นพลังขับเคลื่อน`)
};

const tr_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odağını harekete dönüştür.`)
};

const zh_cn_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`燃起焰不可挡的气势，种下一整片鸿运当头。`)
};

const zh_tw_daily_paywall_exclusive_tree_fire_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種下焰不可擋的熱情，收穫整片鴻運當頭。`)
};

/**
* | output |
* | --- |
* | "Turn focus into momentum." |
*
* @param {Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_exclusive_tree_fire_subtitle = /** @type {((inputs?: Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Exclusive_Tree_Fire_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "ar") return ar_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "de") return de_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "es") return es_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "fr") return fr_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "it") return it_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "ja") return ja_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "ko") return ko_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "ru") return ru_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "th") return th_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "tr") return tr_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_exclusive_tree_fire_subtitle(inputs)
	return zh_tw_daily_paywall_exclusive_tree_fire_subtitle(inputs)
});